import React, { useState, ReactNode } from "react";

export default function GeneralCard({
  title,
  desc,
  isSelected = false,
  onCardClick,
  showDetailsSection = false,
  detailsContent,
}) {
  const [showDetails, setShowDetails] = useState(false);

  const handleButtonClick = () => {
    if (onCardClick) {
      onCardClick(); // Use parent's click handler if provided
    } else {
      setShowDetails(!showDetails); // Fallback to local state
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="flex flex-col gap-4">
        <button
          className="flex flex-col items-center justify-center w-40 h-40 lg:w-[148px] lg:h-[148px] shadow shadow-gray-500 hover:shadow-lg transition-shadow cursor-pointer"
          onClick={handleButtonClick}
        >
          <p className="font-bold text-xl md:text-2xl">{title}</p>
          <p>{desc}</p>
        </button>
      </div>

      {/* 2-column span details section (new functionality) */}
      {showDetailsSection && isSelected && detailsContent && (
        <div className="w-80">{detailsContent}</div>
      )}
    </div>
  );
}
